import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col py-2" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "flex w-full py-3 transition-colors cursor-pointer px-7 hover:bg-primary-100 dark-hover:bg-gray-800" };
const _hoisted_4 = { class: "flex flex-col items-start justify-end ml-3 truncate" };
const _hoisted_5 = { class: "max-w-full text-sm font-bold truncate text-wyeworks-black dark:text-gray-300" };
const _hoisted_6 = { class: "max-w-full text-xs text-gray-400 truncate dark:text-gray-400" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserDropdown',
    props: {
        users: null
    },
    emits: ['selected'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_Avatar = _resolveComponent("Avatar");
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, (user) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: user.id,
                        onClick: ($event) => (_ctx.$emit('selected', user))
                    }, [
                        _createElementVNode("li", _hoisted_3, [
                            _createVNode(_component_Avatar, {
                                user: user,
                                "show-tooltip": false
                            }, null, 8, ["user"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(user.name), 1),
                                _createElementVNode("h2", _hoisted_6, _toDisplayString(user.email), 1)
                            ])
                        ])
                    ], 8, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
